import React, { createContext, useContext, ReactNode, useState, useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { UISession } from 'types';

export interface SessionContextOptions {
	session: UISession | null;
	refetchUserDetails: boolean;
	setRefetchUserDetails: React.Dispatch<React.SetStateAction<boolean>>;
	setSession: React.Dispatch<React.SetStateAction<UISession | null>>;
}
export interface SessionContextProps {
	children: ReactNode;
}

const SessionContext = createContext<SessionContextOptions>({
	session: null,
	setSession: () => {},
	refetchUserDetails: false,
	setRefetchUserDetails: () => {},
});

export const SessionContextProvider = ({ children }: SessionContextProps) => {
	const queryClient = useQueryClient();
	const [session, setSession] = useState<UISession | null>(null);
	const [refetchUserDetails, setRefetchUserDetails] = useState(false);

	useEffect(() => {
		const refetch = setInterval(() => {
			if (refetchUserDetails) {
				queryClient.refetchQueries(['verifyCookie']);
				queryClient.refetchQueries(['getSessions']);
			}
		}, 15000);

		return () => {
			if (!refetchUserDetails) clearInterval(refetch);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [refetchUserDetails]);

	return (
		<SessionContext.Provider
			value={{
				session,
				setSession,
				refetchUserDetails,
				setRefetchUserDetails,
			}}
		>
			{children}
		</SessionContext.Provider>
	);
};

export const useSessionContext = () => {
	const context = useContext(SessionContext);
	return context;
};
